import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import * as CuentaContableService from 'services/cuentaContable.service'

import { KeyEventUtil } from 'utils'

const CuentaDestinoFormGroup = ({
  iError,
  iTouched,
  fIsSubmitting,
  handleChange,
  setFieldValue
}) => {
  const [cuentasContables, setCuentaContable] = React.useState([])

  React.useEffect(() => {
    CuentaContableService.getCuentasContablesParaCAsSelect()
      .then(({ data }) => {
        setCuentaContable(data)
      })
      .catch(() => setCuentaContable([]))
  }, [])

  const onChange = React.useCallback(
    e => {
      handleChange(e)
      const matchedCentro = cuentasContables.find(x => x.value === e.target.value)
      if (matchedCentro) {
        setFieldValue('cuentaDestinoInfo', matchedCentro.label)
      } else {
        setFieldValue('cuentaDestinoInfo', '')
      }
    },
    [handleChange, setFieldValue, cuentasContables]
  )

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('nuevoasiento-agregar-button', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='DESTINO' htmlFor='select-cuentaDestino' md={12} />
      <Col md={12}>
        <Field name='cuentaDestino'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-cuentaDestino'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
              onChange={onChange}
            >
              <option value=''>Seleccionar</option>
              {cuentasContables.map((x, k) => (
                <option key={k} value={x.value}>
                  {x.label}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaDestinoFormGroup)
